var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$route.query.type == '0')?_c('div',{staticClass:"reading-btn",on:{"click":_vm.toPaperRead}},[_vm._v(" 阅读 ")]):_c('div',{staticClass:"reading-btn",on:{"click":_vm.toRead}},[_vm._v("阅读")])
}
var staticRenderFns = []

export { render, staticRenderFns }